/**
 * Whether a master-data order type is the X-Ray order type, matched by name.
 *
 * X-Ray is managed as a facility-scoped master-data order type (admin portal).
 * Availability follows the facility assignment; this helper only recognises the
 * X-Ray entry by name so the frontend can apply the care-type gate and route it
 * to the dedicated X-Ray form. Matches "X-Ray", "X Ray", "Xray", "x-ray".
 */
export const isXRayName = (name?: string): boolean =>
  (name || "").toLowerCase().replace(/[\s-]/g, "") === "xray";
